import { Anchor, Group, Space } from "@mantine/core";
import { NavLink } from "react-router-dom";
import BreadcrumbsNavigation from "@/components/breadcrumbs-navigation";
import CardEmpresa from "@/modules/diagnostico/components/cards/CardEmpresa";
import QuestionariosList from "@/modules/diagnostico/components/questionarios-list";

const EmpresaDiagnosticoPage = () => {
  return (
    <>
      <BreadcrumbsNavigation notHome={true}>
        <Anchor component={NavLink} to="/diagnostico">
          Home
        </Anchor>
      </BreadcrumbsNavigation>
      <Group>
        <CardEmpresa />
      </Group>
      <Space h="md" />
      <QuestionariosList />
    </>
  );
};

export default EmpresaDiagnosticoPage;
